import Cookie from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import cryptoRandomString from 'crypto-random-string-with-promisify-polyfill';

export const getNonce = () => Cookie.get('nonce');
export const removeNonce = () => Cookie.remove('nonce');
export const setNonce = (value = cryptoRandomString({ length: 20, type: 'url-safe' })) => {
  Cookie.set('nonce', value);
  return value;
};
export const getAuthToken = () => Cookie.get('token');
export const removeAuthToken = () => Cookie.remove('token');
export const setAuthToken = (token, date) => Cookie.set('token', token, { expires: date });

export const decodeJwt = token => {
  try {
    return jwtDecode(token);
  } catch {
    return undefined;
  }
};

export const getExpiryDate = decodedToken => {
  const date = new Date(0);
  date.setUTCSeconds(decodedToken.exp);
  return date;
};

const ENVIRONMENT = window.__env__.ENV;

const getClientId = () => {
  if (ENVIRONMENT === 'integration') {
    return '885690037715-o448lma4toslglg7rpcma6ram0i1pvp3.apps.googleusercontent.com';
  }

  if (ENVIRONMENT === 'prod') {
    return '542110102871-6veht9j2lkjv94ohdn8ivdr8k9voe9mk.apps.googleusercontent.com';
  }

  if (
    ENVIRONMENT === 'stubs' ||
    ENVIRONMENT === 'local' ||
    // can we get rid of this?
    process.env.REACT_APP_ENV === 'dev' ||
    ENVIRONMENT === 'vitest-tests'
  ) {
    return '885690037715-mkmu14jp17ev641l1qfkme2o08i5rfhg.apps.googleusercontent.com';
  }

  throw new Error('Environment variable not matching:', ENVIRONMENT);
};

export const getAuthInfoFromHash = hash => {
  const hashlessString = hash.replace(/^#/, '');
  const pieces = hashlessString.split('&');

  const token = pieces.find(string => string.includes('id_token='));
  const statePiece = pieces.find(string => string.includes('state='));
  const state = statePiece && statePiece.replace('state=', '').replace(/^\//, '');

  if (!token) {
    throw new Error('Malformed URI.');
  }

  return {
    token: token.replace('id_token=', ''),
    state: state,
  };
};

export function buildIdentityProviderUrl(overrideState = undefined) {
  const clientId = getClientId();
  const { origin: redirectUri, pathname, search } = window.location;

  const state = overrideState || encodeURIComponent(`${pathname}${search}`);

  const nonce = setNonce();
  return `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=id_token%20token&access_type=online&scope=email%20openid%20profile&nonce=${nonce}&state=${state}`;
}

export const redirectToIdentityProvider = () => {
  window.location = buildIdentityProviderUrl();
};

export const getUser = () => {
  const token = getAuthToken();
  if (token) {
    return decodeJwt(token) || {};
  }

  return {};
};
